import { render, staticRenderFns } from "./DstudioBotConfiguration.vue?vue&type=template&id=23c69646&scoped=true&"
import script from "./DstudioBotConfiguration.vue?vue&type=script&lang=js&"
export * from "./DstudioBotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DstudioBotConfiguration.vue?vue&type=style&index=0&id=23c69646&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c69646",
  null
  
)

export default component.exports